export const AWARD_SHARE_CODE_PARAM = 'code';
export const AWARD_SHARE_TITLE_PARAM = 'title';
export const AWARD_SHARE_BACK_PARAM = 'backLocation';